import React, { memo, useState } from 'react'
import { Col, Row, } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import DeleteCustomerAddressModal from './DeleteCustomerAddress/DeleteCustomerAddressModal'
import CustomerAddressModal from './AddCustomerAddress/CustomerAddressModal'
import { Link } from 'react-router-dom';

function CustomersDefalutAddress(props) {
    const { address, refreshAddress, countries = [] } = props
    const [edit, setEdit] = useState(false)
    const [_delete, setDelete] = useState(false)

    if (!address) {
        return null
    }
    return (
        <div>
            {edit && <CustomerAddressModal
                show={edit}
                userId={address.user_id}
                closeModal={() => {
                    setEdit(false)
                }}
                onSave={refreshAddress}
                addressData={address}
                countries={countries}
            />}
            {_delete && <DeleteCustomerAddressModal
                show={_delete}
                onSave={refreshAddress}
                address_id={address.address_id}
                closeModal={() => {
                    setDelete(false)
                }}
            />}

            < div className="app-card mb-3 mb-lg-4 customer-address" >
                <div className="app-card-content border st-default-rounded-block mb-3 pad-20" style={{ minHeight: 295 }}>
                    <Row>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="">
                                <div className="app-header-wrapper">
                                    <p className="app-heading text-capitalize st-fs-14 st-fw-600 address-heading">{"Default "}{address.address_type}{" Address"}</p>
                                </div>

                            </div>
                            <div>
                                <div className="header d-flex p-0" style={{ height: "auto" }}>
                                    <div className="header-menu d-flex">
                                        <div className="hm_item notifications">
                                            <Link
                                                to="#"
                                                className="st-round-btn st-btn-sm st-btn-white border st-border-light d-flex align-items-center justify-content-center"
                                                title="Notifications">
                                                <FeatherIcon
                                                    icon="more-vertical"
                                                    size="15"
                                                    className="icon-main" />
                                            </Link>
                                            <div className="header-dropdown w-50">
                                                <div className="hd_inner st-default-rounded-block ">
                                                    <div className="all-links">
                                                        <Link to="#" className="link-item text-decoration-none d-flex"
                                                            onClick={() => {
                                                                setEdit(true)
                                                            }}>
                                                            <div className="text media-body ps-3">
                                                                <p className="message st-fs-14">
                                                                    Edit
                                                                </p>
                                                            </div>
                                                        </Link>
                                                        <Link to="#" className="link-item text-decoration-none d-flex"
                                                            onClick={() => {
                                                                setDelete(true)
                                                            }}>
                                                            <div className="text media-body ps-3">
                                                                <p className="message st-fs-14">
                                                                    Delete
                                                                </p>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <Col xs={12} md={12} lg={12} className="p-3 border-bottom st-border-light">
                            <Row>
                                <Col xs={12} md={12} lg={4}>
                                    <span className="st-fs-13 st-fw-600">Name:</span>
                                </Col>
                                <Col xs={12} md={12} lg={8}>
                                    <p className="app-heading text-uppercase st-fw-600 st-fs-15">
                                        {`${address.shipping_first_name} ${address.shipping_middle_name}  ${address.shipping_last_name}`}
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-3 border-bottom st-border-light">
                            <Row>
                                <Col xs={12} md={12} lg={4}>
                                    <span className="st-fs-13 st-fw-600">Address:</span>
                                </Col>
                                <Col xs={12} md={12} lg={8}>
                                    <p className="app-heading text-capitalize text-left st-fw-600 st-fs-15">
                                        {address.shipping_address}<br />
                                        {`${address.city}, ${address.state}, ${address.shipping_zipcode}`}<br />
                                        {address.country}
                                    </p>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} md={12} lg={12} className="p-3 pb-0">
                            <Row>
                                <Col xs={12} md={12} lg={4}>
                                    <span className="st-fs-13 st-fw-600">Mobile:</span>
                                </Col>
                                <Col xs={12} md={12} lg={8}>
                                    <p className="app-heading st-fw-600 st-fs-15">{address.shipping_mobile}</p>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div >
        </div>
    )
}

export default memo(CustomersDefalutAddress)